export function fmtUsd(n) {
  if (n == null || isNaN(n)) return "—";
  const a = Math.abs(n);
  const s = n < 0 ? "-$" : "$";
  if (a >= 1e9) return `${s}${(a / 1e9).toFixed(2)}B`;
  if (a >= 1e6) return `${s}${(a / 1e6).toFixed(2)}M`;
  if (a >= 1e3) return `${s}${(a / 1e3).toFixed(1)}K`;
  return `${s}${a.toFixed(2)}`;
}

export function fmtPrice(n) {
  if (!n || isNaN(n)) return "—";
  if (n >= 1) return `$${n.toLocaleString(undefined, { maximumFractionDigits: 4 })}`;
  return `$${n.toLocaleString(undefined, { maximumSignificantDigits: 4 })}`;
}

export function fmtPct(n) {
  if (n == null || isNaN(n)) return "—";
  const s = n > 0 ? "+" : "";
  return `${s}${Number(n).toFixed(2)}%`;
}

export function fmtNum(n) {
  if (n == null || isNaN(n)) return "—";
  return Number(n).toLocaleString();
}

export const CHAIN_META = {
  solana: { label: "Solana", color: "#00E5FF" },
  ethereum: { label: "Ethereum", color: "#A855F7" },
  bsc: { label: "BNB Chain", color: "#FFB800" },
  base: { label: "Base", color: "#3B82F6" },
  robinhood: { label: "Robinhood", color: "#CCFF00" },
};
